export const Badge = {
  variants: {
    count: {
      color: 'product.text.dark.bodySolid',
      bg: 'product.gray.100',
      minW: 5,
      textAlign: 'center',
      py: 0.5,
    },
  },
}
